export default __webpack_public_path__ + "static/media/01.f9c8038f.png";